import React, { ComponentType, FunctionComponent } from 'react';

/**
 * Transform attachments object into clickable button to download a pdf for each attachment
 *
 * @param Component
 * @param params `icon`: show the download icon before the file name
 */
function withAttachmentsFiles(
  Component: ComponentType<any>,
  params: Record<string, any> | undefined
): FunctionComponent {
  const { icon = false } = params || {};

  const Extension: FunctionComponent<Record<string, any>> = (props) => {
    const { record, source } = props;

    if (!record || !record[source]) return null;

    const rawData = record[source] || record['pdfs'];
    // Normalize to array
    const attachments = Array.isArray(rawData)
      ? rawData
      : rawData && typeof rawData === 'object'
      ? [rawData]
      : [];

    if (attachments.length === 0) return null;

    const buttons = attachments.map((attachment: Record<string, any>) => ({
      id: attachment.name,
      href: attachment.public_url,
      label: attachment.name,
      icon,
      target: '_blank',
      rel: 'noopener',
    }));

    return <Component {...props} record={{ ...record, [source]: buttons }} />;
  };

  Extension.displayName = `withExtension(AttachmentsFiles)`;

  return Extension;
}

export default withAttachmentsFiles;
